import React from 'react';

import { getQueryParams } from 'src/lib/history';

import CreateRuleModal from './CreateRuleModal';
import EditRuleModal from './EditRuleModal';
import EditV3RuleModal from './EditV3RuleModal';

const OneRuleModal = () => {
  const { isNew, isLegacy, id } = getQueryParams();
  if (isLegacy === 'true') return <EditV3RuleModal ruleId={id}/>;
  if (isNew === 'true') return <CreateRuleModal/>;
  else return <EditRuleModal ruleId={id}/>;
};

export default OneRuleModal;
